
import { Vue, Component } from 'vue-property-decorator'
import User from '@/types/user'

@Component({
  components: {}
})

export default class CustomerUserEditDetailsTab extends Vue {
  settings = {
    routeNames: { show: 'customerUserShow', edit: 'customerUserEdit' },
    routeParamKey: 'customerUserId',
    functionNames: { setCurrent: 'setCurrentCustomerUser', clearCurrent: 'clearCurrentCustomerUser', save: 'saveCustomerUser' },
    getterNames: { current: 'currentCustomerUser', loading: 'loadingCustomerUser', errors: 'customerUserErrors' }
  }

  newPassword = false

  get currentItem () : User {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }
}
